import { rootApi } from "../rootApi";

export const packageDefinitionsApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        // LIST
        getPackages: builder.query({
            query: ({ search = "", pageNumber = 1, pageSize = 10 }) => ({
                url: `v1/dealerpackages/get-list?${new URLSearchParams({
                    ...(search ? { search } : {}),
                    pageNumber,
                    pageSize,
                })}`,
                method: "GET",
            }),
            transformResponse: (resp) => ({
                rows: resp?.data?.rows ?? [],
                totalCount: resp?.data?.totalCount ?? 0,
            }),
            providesTags: ["DealerPackages"],
        }),


        // DETAIL
        getPackageById: builder.query({
            query: ({ id, languageId = 2 }) => ({
                url: `v1/dealerpackages/${id}?${new URLSearchParams({ languageId })}`,
                method: "GET",
            }),
            transformResponse: (resp) => resp?.data ?? {},
            providesTags: (result, error, arg) => [{ type: "DealerPackages", id: arg.id }],
        }),


        // CREATE
        createPackage: builder.mutation({
            query: (payload) => ({
                url: "v1/dealerpackages/create-package",
                method: "POST",
                body: payload,
                headers: { "Content-Type": "application/json" },
            }),
            invalidatesTags: ["DealerPackages"],
        }),


        // UPDATE
        updatePackage: builder.mutation({
            query: (payload) => ({
                url: "v1/dealerpackages/update-package",
                method: "PUT",
                body: payload,
                headers: { "Content-Type": "application/json" },
            }),
            invalidatesTags: ["DealerPackages"],
        }),

        // PARTS LIST
        fetchParts: builder.query({
            query: ({ q = "", pageNumber = 1, pageSize = 100, languageId = 2 }) => ({
                url: `v1/partlabormapping/get-parts?${new URLSearchParams({
                    partCode: q,
                    pageNumber,
                    pageSize,
                    languageId
                })}`,
                method: "GET"
            }),
            transformResponse: (resp) => resp?.data?.items ?? []
        }),
    }),
});

export const {
    useGetPackagesQuery,
    useLazyGetPackagesQuery,
    useGetPackageByIdQuery,
    useLazyGetPackageByIdQuery,
    useCreatePackageMutation,
    useUpdatePackageMutation,
    useFetchPartsQuery,
    useLazyFetchPartsQuery
} = packageDefinitionsApi;